import { createSlice } from '@reduxjs/toolkit';

const documentSlice = createSlice({
  name: 'docs',
  initialState: {
    drivingLicenseData: {},
    drivingLicenseDataIsLoading: false,
    drivingLicenseDataErrorMsg: null,

    aadharCardData: {},
    aadharCardDataIsLoading: false,
    aadharCardDataErrorMsg: null,

    panCardData: {},
    panCardDataIsLoading: false,
    panCardDataErrorMsg: null,
  },
  reducers: {
    drivingLicenseReq: (state, action) => { },
    drivingLicenseSuccess: (state, action) => ({
      ...state,
      drivingLicenseData: action.payload,
      drivingLicenseDataIsLoading: false,
      drivingLicenseDataErrorMsg: null,
    }),
    drivingLicenseFailure: (state, action) => ({
      ...state,
      drivingLicenseDataIsLoading: false,
      drivingLicenseDataErrorMsg: action.payload,
    }),
    drivingLicenseLoading: (state) => ({
      ...state,
      drivingLicenseDataIsLoading: true,
      drivingLicenseDataErrorMsg: null,
    }),
    drivingLicenseClear: (state) => ({
      ...state,
      drivingLicenseData: {},
      drivingLicenseDataIsLoading: false,
      drivingLicenseDataErrorMsg: null,
    }),

    panCardReq: (state, action) => { },
    panCardSuccess: (state, action) => ({
      ...state,
      panCardData: action.payload,
      panCardDataIsLoading: false,
      panCardDataErrorMsg: null,
    }),
    panCardFailure: (state, action) => ({
      ...state,
      panCardDataIsLoading: false,
      panCardDataErrorMsg: action.payload,
    }),
    panCardLoading: (state) => ({
      ...state,
      panCardDataIsLoading: true,
      panCardDataErrorMsg: null,
    }),
    panCardClear: (state) => ({
      ...state,
      panCardData: {},
      panCardDataIsLoading: false,
      panCardDataErrorMsg: null,
    }),

    aadharCardReq: (state, action) => { },
    aadharCardSuccess: (state, action) => ({
      ...state,
      aadharCardData: action.payload,
      aadharCardDataIsLoading: false,
      aadharCardDataErrorMsg: null,
    }),
    aadharCardFailure: (state, action) => ({
      ...state,
      aadharCardDataIsLoading: false,
      aadharCardDataErrorMsg: action.payload,
    }),
    aadharCardLoading: (state) => ({
      ...state,
      aadharCardDataIsLoading: true,
      aadharCardDataErrorMsg: null,
    }),
    aadharCardClear: (state) => ({
      ...state,
      aadharCardData: {},
      aadharCardDataIsLoading: false,
      aadharCardDataErrorMsg: null,
    }),
  },
});

export const {
  drivingLicenseClear,
  drivingLicenseFailure,
  drivingLicenseLoading,
  drivingLicenseReq,
  drivingLicenseSuccess,

  aadharCardClear,
  aadharCardFailure,
  aadharCardLoading,
  aadharCardReq,
  aadharCardSuccess,

  panCardClear,
  panCardFailure,
  panCardLoading,
  panCardReq,
  panCardSuccess,
} = documentSlice.actions;

export default documentSlice.reducer;
